export class DictionaryCountry {
  public constructor(
    private readonly data: {
      id: string;
      isoCode: string;
      label: string;
    },
  ) {}

  public get id(): string {
    return this.data.id;
  }

  public get isoCode(): string {
    return this.data.isoCode;
  }

  public get label(): string {
    return this.data.label;
  }
}
